import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {from, Observable, switchMap} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({providedIn: 'root'})
export class PaymentService {
  constructor(private http: HttpClient) {}

  createPaymentIntent(orderId: string): Observable<any> {
    return from(environment).pipe(
      switchMap((env: any) =>
        this.http.post(`${env.backendURL}/api/payments/create-intent`, {orderId})
      )
    );
  }

  confirmPayment(paymentIntentId: string): Observable<any> {
    return from(environment).pipe(
      switchMap((env: any) =>
        this.http.post(`${env.backendURL}/api/payments/confirm`, {paymentIntentId})
      )
    );
  }

  startConnectOnboarding(): Observable<any> {
    return from(environment).pipe(
      switchMap((env: any) =>
        this.http.post(`${env.backendURL}/api/payments/connect/onboard`, {})
      )
    );
  }

  getConnectStatus(): Observable<ConnectStatus> {
    return from(environment).pipe(
      switchMap((env: any) =>
        this.http.get<ConnectStatus>(`${env.backendURL}/api/payments/connect/status`)
      )
    );
  }
}

export interface ConnectStatus {
  mode: string;
  connected: boolean;
  detailsSubmitted?: boolean;
  chargesEnabled?: boolean;
  payoutsEnabled?: boolean;
  stripeConnectAccountId?: string;
  message?: string;
}
